export type Destination = 'sessions' | 'catchup' | 'accounts' | 'devices'
export interface Route {
  path: string
  destination: Destination
  kind: string
  ref?: string
  output?: string
  turn?: string
  rel?: string
  directory?: boolean
}
export const destinations = [
  ['sessions', 'Sessions', '#/', 'sessions'],
  ['catchup', 'Catch up', '#/catchup', 'check-double'],
  ['accounts', 'Accounts', '#/accounts', 'usage'],
  ['devices', 'Devices', '#/devices', 'devices'],
] as const

const decode = (value: string) => {
  try { return decodeURIComponent(value) } catch { return value }
}
const root = (destination: Destination): Route => ({ path: destination === 'sessions' ? '#/' : '#/' + destination, destination, kind: destination })
const destinationOf = (first: string): Destination =>
  first === 'catchup' ? 'catchup' : ['devices', 'settings', 'ports'].includes(first) ? 'devices' : first === 'accounts' ? 'accounts' : 'sessions'

/** Cold links carry their parent entries. */
export function routes(hash: string): Route[] {
  const path = '#' + (hash.replace(/^#/, '').replace(/\/+$/, '') || '/')
  const bits = path.slice(2).split('/')
  const destination = destinationOf(bits[0])
  const result = [root(destination)]
  const add = (kind: string, path: string, extra: Partial<Route> = {}) => result.push({ path, destination, kind, ...extra })
  if (typeof __CX_DEMO__ !== 'undefined' && __CX_DEMO__ && bits[0] === 'gallery') {
    add('gallery', path)
    return result
  }
  if (['settings', 'ports', 'new'].includes(bits[0])) {
    add(bits[0], path)
    return result
  }
  const prefix = destination === 'catchup' ? '/catchup' : ''
  const offset = prefix ? 1 : 0
  if (bits[offset] === 's' && bits[offset + 1]) {
    const ref = decode(bits[offset + 1])
    const base = '#' + prefix + '/s/' + bits[offset + 1]
    add('session', base, { ref })
    if (bits[offset + 2] === 'changes' && bits[offset + 3]) add('changes', path, { ref, turn: decode(bits[offset + 3]) })
    else if (bits[offset + 2] === 'outputs' || bits[offset + 2] === 'o') {
      add('outputs', base + '/outputs', { ref })
      if (bits[offset + 2] === 'o' && bits[offset + 3]) {
        add('output', path, { ref, output: decode(bits[offset + 3]), directory: bits[offset + 4] === 'd', rel: bits.slice(offset + 5).map(decode).join('/') })
      }
    }
  } else if (bits[0] === 'outputs') {
    add('outputs', '#/outputs')
    if (bits[1] === 'o' && bits[2]) add('output', path, { output: decode(bits[2]), directory: bits[3] === 'd', rel: bits.slice(4).map(decode).join('/') })
  }
  return result
}
